(function () {
  const btn = document.querySelector('[data-copy-prompt]');
  const pre = document.querySelector('[data-prompt-text]');
  if (!btn || !pre) return;

  const original = btn.textContent;
  let resetTimer = null;

  function markCopied() {
    btn.textContent = 'copiado ✓';
    clearTimeout(resetTimer);
    resetTimer = setTimeout(() => { btn.textContent = original; }, 2500);
  }

  function fallbackCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); markCopied(); } catch (_) {}
    document.body.removeChild(ta);
  }

  btn.addEventListener('click', () => {
    const text = pre.textContent.trim();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(markCopied).catch(() => fallbackCopy(text));
    } else {
      fallbackCopy(text);
    }
  });
})();
